import styled from 'styled-components';
var FormatFileSize = styled.span.withConfig({
  displayName: "FormatFileSizestyles__FormatFileSize",
  componentId: "sc-bt2a1h-0"
})(["font-feature-settings:'kern','liga','calt','case','ss03','cv03','cv04','tnum';"]);
export var Styled = {
  FormatFileSize: FormatFileSize
};